import React from "react";
import { Container } from "react-bootstrap";
import style from "./dashboard.module.scss";
import Profiles from "./profiles";
import Tile from "./Tile";
import DashboardModel from "./DashboardModal";
import { useTranslation } from "react-i18next";
import "./styles.css";
import AddForm from "./AddForm";
import VerificationForm from "./VerificationForm";

function MainContent(props) {
  console.log(props, "props in main content");
  const { t } = useTranslation();
  const chartData = props.chartResult;

  return (
    <Container fluid className={`p-3`} style={props?.style}>
      {/* <NewProfile profile={props.profile}/> */}
      {/* <div className="move-text">Your moving text Announcement here</div> */}
      <div className={style.left_navigation_fold}>
        <div className={style.main_contant_sec}>
          <section className={style.contant_sec}>
            <div className={style.cntr_main_cnt_sc}>
              <div className={style.dashboard_main_cnt}>
                {props.profile && (
                  <Profiles
                    profile={props.profile}
                    lodervalue={props.tiles_loading}
                  />
                )}
                <div>
                  <Tile
                    start_date={props.start_date}
                    end_date={props.end_date}
                    profile={props.profile}
                    data={props?.data}
                    chartData={chartData}
                    pvData={props.extra_data}
                    SponserData={props.sponser_details}
                    announcements={props.announcement}
                    maintenance={props.maintanace}
                    cycleCount={props.dailyCycleCount}
                    new_members={props.new_members}
                    rank={props.rank}
                    commissionFlow={props.commissionFlow}
                    Tiles={props.tiles}
                    filterChange={props.filterChange}
                    lodervalue={props.tiles_loading}
                    totalgsr={props.totalGSR}
                    totalPSD={props.totalPSD}
                    totalCycle={props?.totalCycle}
                    todayResponse={props.todayResponse}
                    accumulatedResponse={props.accumulatedResponse}
                    lifeTimeIncomeChart={props.lifeTimeIncomchart}
                    chartResult={props.chartResult}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <DashboardModel show={props.modal.show} title={props.modal.title}>
        {!props.continue && <AddForm {...props}></AddForm>}
        {props.continue && <VerificationForm {...props}></VerificationForm>}
      </DashboardModel>
    </Container>
  );
}

export default MainContent;
